import { PBRMetallicRoughnessMaterial, Scene } from '@babylonjs/core';
import { WoodMaterial } from './woodMaterial';

class MaterialFactory {
    private materials: any[] = [WoodMaterial];

    public get(hash: string, scene: Scene, light: string = ''): PBRMetallicRoughnessMaterial {
        return this.materials
            .find((x) => x.hash === hash)!
            .get(scene, light);
    }
}

export const materialFactory = new MaterialFactory();
